import * as yup from 'yup';


// Schema for validation
export const AddAdminSchema = yup.object().shape({
    user_type: yup.string().required('Please select a user type'),
    full_name: yup.string().required('Please enter your name'),
    phone_number: yup
        .string()
        .required('Please enter your phone number')
        .test(
            'len',
            'Phone number must be exactly 10 digits.',
            val => val && val.length === 10 && /^\d+$/.test(val)
        ),
    email: yup.string().email('Please enter correct email address.').required('Please enter your email address')

});

export const AddCompanySchema = (watchedUserType) => yup.object().shape({
    user_type: yup.string().required('Please select a user type'),
    company: yup.string().required('Please enter the company name'),
    phone_number: yup
        .string()
        .required('Please enter your phone number')
        .test(
            'len',
            'Phone number must be exactly 10 digits.',
            val => val && val.length === 10 && /^\d+$/.test(val)
        ),
    email: yup.string().email('Please enter correct email address.').required('Please enter your email address'),
    recruiter_name: watchedUserType === 'recruiter' ? yup.string().required('Please enter the recruiter name') : yup.string().notRequired()
});
